/** Role names joined as text in the viewer's language: «مدير المرافق، فني الصيانة» in Arabic (the Arabic comma), "A, B" otherwise. */
export function joinRoleLabels(labels: readonly string[], lang: string | null | undefined): string {
  return labels.join(lang === 'ar' ? '، ' : ', ');
}
